import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-192" data-mp="3kqnsmw4m036i">
      <div className="mx-auto max-w-5xl" data-id="element-193" data-mp="3ksgzocj4wpf1">
        <h2 className="text-center text-[1.75rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.4rem]" data-id="element-194" data-mp="3fz5ndvvjzgfq">
          What Teachers Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-stone-700" data-id="element-195" data-mp="3ayqat6j3icyt">
          <span aria-hidden="true" data-id="element-196" data-mp="370ajwrjw8kg4">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1,500 Teachers & Trainers
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-2" data-id="element-197" data-mp="31yl6j5977uov">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-stone-100 p-6" data-id="element-198" data-mp="2x2w2opq5brmr">
              <div className="text-sm text-amber-500" aria-label="5 out of 5 stars" data-id="element-199" data-mp="2s3t8y1fm97u3">
                <span aria-hidden="true" data-id="element-200" data-mp="v8wvogk23wfv">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-stone-800" data-id="element-201" data-mp="qbevbek3upjh">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-202" data-mp="m4rncafq7a5d">
                <p className="text-xs font-bold text-stone-900" data-id="element-203" data-mp="m5t1ins1gcrb">{item.name}</p>
                <p className="text-xs text-stone-500" data-id="element-204" data-mp="78jzn053zqlc">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-stone-400" data-id="element-205" data-mp="c73rtiaapym5">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}